// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Import server Config
import apiLink from '@configs/serverConfig'

// ** Axios Imports
import axios from 'axios'

// ** Rent
export const getServicesList = createAsyncThunk('appServices/getServicesList', async params => {
    params.page = params.page === 0 ? 0 : params.page - 1
    const response = await axios.post(apiLink('getServicesList'), params)
    return {
        params,
        data: response.data.content,
        totalPages: response.data.totalElements
    }
})
export const addService = createAsyncThunk('appServices/addService', async (data) => {
    const response = await axios.post(apiLink('addService'), data)
    return response.data
})
export const updateService = createAsyncThunk('appServices/updateService', async (data) => {
    const service_id = data.id
    delete data.id
    const response = await axios.put(apiLink({name: 'updateService', value: service_id}), data)
    return response.data
})
export const getService = createAsyncThunk('appServices/getService', async (id) => {
    const response = await axios.get(apiLink({name: 'getService', value: id}))
    return response.data
})
export const removeService = createAsyncThunk('appServices/removeService', async (id) => {
    const response = await axios.delete(apiLink({name: 'removeService', value: id}))
    return response.data
})

export const getServiceGroups = createAsyncThunk('appServices/getServiceGroups', async data => {
    const response = await axios.post(apiLink({name: 'getServiceGroups'}), data)
    return response.data.content
})
export const getServiceGroupChildren = createAsyncThunk('appServices/getServiceGroupChildren', async data => {
    const response = await axios.get(apiLink({name: 'getServiceGroupChildren', value: data.group_id}))
    return response.data
})
export const getServiceGroup = createAsyncThunk('appServices/getServiceGroup', async (id) => {
    const response = await axios.get(apiLink({name: 'getServiceGroup', value: id}))
    return response.data
})
export const addServiceGroup = createAsyncThunk('appServices/addServiceGroup', async (data) => {
    if (data.parent_group_id === 0) {
        delete data.parent_group_id
    }
    const response = await axios.post(apiLink('addServiceGroup'), data)
    return response.data
})
export const editServiceGroup = createAsyncThunk('appServices/editServiceGroup', async (data) => {
    const response = await axios.put(apiLink({name: 'editServiceGroup', value: data.id}), data)
    return response.data
})
export const removeServiceGroup = createAsyncThunk('appServices/removeServiceGroup', async (id) => {
    const response = await axios.delete(apiLink({name: 'removeServiceGroup', value: id}))
    return response.data
})
export const getServicesByGroup = createAsyncThunk('appServices/getServicesByGroup', async data => {
    const response = await axios.post(apiLink('getServicesList'), data)
    return response.data
})
export const importServices = createAsyncThunk('appServices/importServices', async () => {
    const response = await axios.post(`https://api.mfauto.com.ua/repair/import/services?env=${process.env.REACT_APP_NODE_ENV}`, {
        token: localStorage.getItem('token')
    })
    return response
})


export const appServicesSlice = createSlice({
    name: 'appServices',
    initialState: {
        data: [],
        total: 1,
        params: {},
        settings: [],
        selectedService: null,
        parentGroupName: '',
        parentGroupId: '',
        groups: []
    },
    reducers: {},
    extraReducers: builder => {
    builder
        .addCase(getServicesList.fulfilled, (state, action) => {
            state.data = action.payload.data
            state.params = action.payload.params
            state.total = action.payload.totalPages
        })      
        .addCase(getServiceGroups.fulfilled, (state, action) => {

            const map = new Map()
            const tree = []

            action.payload.forEach(item => {
                map.set(item.id, { ...item, children: [] })
            })
                        
            action.payload.forEach(item => {
                if (item.parent_group_id) {                    
                    map.get(item.parent_group_id).children.push(map.get(item.id))
                } else {                    
                    tree.push(map.get(item.id))
                }
            })            

            state.groups = tree
        })
        .addCase(getServiceGroupChildren.fulfilled, (state, action) => {
            state.groups = action.payload.children
            state.parentGroupName = action.payload.name
            state.parentGroupId = action.payload.id
        })
        .addCase(getService.fulfilled, (state, action) => {
            state.selectedService = action.payload            
        })
    }
})

export default appServicesSlice.reducer
